import Button from 'components/Form/Button';
import { FormSeparator } from 'components/Form/Core/styled';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { getProfissoes } from 'services/api-omni';
import { Title, Touch } from 'ui/styled';
import { situacOptions } from 'utils/options';
import FormCore from '../../Form/Core';
import Wrapper from '../Wrapper';
import { AddProposalContainer, CompanyButtonContainer } from './styled';

export default function BankingProfissaoOmni({
  dados,
  classesOptions,
  distributorId,
  onConfirm,
}) {
  const { setModal } = useContext(CoreContext);
  const formRefDados = useRef(null);
  const formRefClasse = useRef(null);
  const [ocupations, setOcupations] = useState([]);
  const [search, setSearch] = useState('');
  const [loadingOcupation, setLoadingOcupation] = useState(false);
  const [selectedOcupation, setSelectedOcupation] = useState(null);
  const [currentClasse, setCurrentClasse] = useState(null);

  const close = () => setModal(null);

  const handleGettingOcupations = useCallback(
    async (codeClass) => {
      if (!codeClass) {
        return;
      }
      setLoadingOcupation(true);
      setCurrentClasse(codeClass);
      try {
        const res = await getProfissoes({
          distributorId,
          classeProfissional: codeClass,
        });
        const formatado =
          res?.profissoes?.map((profession) => ({
            id: profession.codigo,
            title: profession.descricao,
          })) || [];
        setOcupations(formatado);
      } catch (err) {
        toast.error('Erro ao buscar ocupações na Omni.');
      } finally {
        setLoadingOcupation(false);
      }
    },
    [distributorId]
  );

  const formItemsEmpresa = [
    {
      ref: 'nome_empresa',
      placeholder: 'Nome da Empresa',
      required: true,
      tress: true,
    },
    {
      ref: 'cnpj_empresa',
      placeholder: 'CNPJ',
      mask: '99.999.999/9999-99',
      tress: true,
    },
    {
      ref: 'telefone_empresa',
      placeholder: 'Telefone da empresa',
      mask: '(99)99999-9999',
      required: true,
      tress: true,
    },
    {
      ref: 'tempo_empresa',
      placeholder: 'Tempo de Empresa (Meses)',
      type: 'number',
      required: true,
      min: 0,
      tress: true,
    },
    {
      ref: 'renda_mensal',
      placeholder: 'Renda Mensal',
      type: 'money',
      required: true,
      tress: true,
    },
    {
      ref: 'patrimonio_estimado',
      placeholder: 'Patrimônio Estimado',
      type: 'money',
      required: true,
      tress: true,
    },
    {
      ref: 'situacao_imovel',
      placeholder: 'Situação do Imóvel',
      required: true,
      options: situacOptions,
      tress: true,
    },
  ];

  const formItemsClasse = [
    {
      ref: 'profissao',
      placeholder: 'Selecione a Classe Profissional',
      type: 'select',
      options: classesOptions,
      onChange: (val) => handleGettingOcupations(val),
    },
  ];

  useEffect(() => {
    if (dados) {
      const preencher = () => {
        Object.keys(dados).forEach((key) => {
          if (dados[key] !== undefined && dados[key] !== null) {
            const valor =
              key === 'profissao' || key === 'situacao_imovel'
                ? String(dados[key])
                : dados[key];
            formRefDados.current?.setItem?.(valor, key);
            formRefClasse.current?.setItem?.(valor, key);
          }
        });
      };
      preencher();
      if (dados.profissao) {
        handleGettingOcupations(dados.profissao);
        if (dados.ocupacao) {
          setSelectedOcupation({
            id: dados.ocupacao,
            title: dados.ocupacao_label || dados.ocupacao,
          });
        }
      }
    }
  }, [dados, handleGettingOcupations]);

  const handleConfirmar = () => {
    const valuesDados = formRefDados.current?.getForm() || {};
    const formValues = { ...valuesDados };
    if (!formValues.nome_empresa || !selectedOcupation || !currentClasse) {
      return toast.warn('Preencha os dados e selecione uma ocupação na lista.');
    }
    const classeLabel = classesOptions.find(
      (classOption) => String(classOption.id) === String(currentClasse)
    )?.title;

    const confirmProps = {
      ...formValues,
      profissao: currentClasse,
      profissao_label: classeLabel,
      ocupacao: selectedOcupation.id,
      ocupacao_label: selectedOcupation.title,
    };

    onConfirm(confirmProps);
    close();
  };
  const filteredOcupations = ocupations.filter((ocupation) =>
    ocupation.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Wrapper title="Informações Profissionais Omni">
      <Title small>Dados da Empresa e Renda</Title>
      <AddProposalContainer>
        <FormCore ref={formRefDados} formItems={formItemsEmpresa} />
      </AddProposalContainer>
      <FormSeparator />
      <Title small>Seleção de Ocupação</Title>
      <AddProposalContainer>
        <FormCore ref={formRefClasse} formItems={formItemsClasse} />
        {ocupations.length > 0 && (
          <div style={{ marginTop: '10px' }}>
            <input
              type="text"
              placeholder="Pesquisar ocupação na lista..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ccc',
              }}
            />
          </div>
        )}
        <div
          style={{
            maxHeight: '250px',
            overflowY: 'auto',
            marginTop: '10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
          }}
        >
          {loadingOcupation && (
            <p style={{ padding: '15px' }}>Carregando ocupações...</p>
          )}
          {!loadingOcupation &&
            filteredOcupations.map((ocupation) => (
              <Touch
                key={ocupation.id}
                onClick={() => setSelectedOcupation(ocupation)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px',
                  borderBottom: '1px solid #eee',
                  backgroundColor:
                    selectedOcupation?.id === ocupation.id ? '#e3f2fd' : '#fff',
                  transition: '0.2s',
                }}
              >
                <div
                  style={{
                    minWidth: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    border: '2px solid #2196f3',
                    marginRight: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {selectedOcupation?.id === ocupation.id && (
                    <div
                      style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#2196f3',
                      }}
                    />
                  )}
                </div>
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight:
                      selectedOcupation?.id === ocupation.id
                        ? 'bold'
                        : 'normal',
                  }}
                >
                  {ocupation.title}
                </span>
              </Touch>
            ))}
          {ocupations.length > 0 && filteredOcupations.length === 0 && (
            <p style={{ padding: '15px' }}>
              Nenhuma ocupação encontrada para "{search}"
            </p>
          )}
        </div>
      </AddProposalContainer>
      <CompanyButtonContainer>
        <Button color="lightgrey" onClick={close} border nospace>
          Cancelar
        </Button>
        <Button color="blue" onClick={handleConfirmar} nospace>
          Confirmar Ocupação
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
}
